import { api } from "@/redux/api";

import { MsdynamicsFieldMapping } from "@/pages/Private/pages/Company/schema/dynamics";

/**
 * A Dynamics mapping's value map (PREC-4363): our value (a gender, a country, a state)
 * translated into what the target field accepts. Kept beside `dynamics.api.ts`, whose
 * endpoints it shares the "Dynamics" cache tag with.
 */
export const dynamicsValueMapApi = api.injectEndpoints({
	endpoints: (builder) => ({
		/** Resolve a mapping's value map again; the user's own entries are kept (PREC-4363). */
		refreshDynamicsValueMap: builder.mutation<MsdynamicsFieldMapping, number>({
			query: (id) => ({ url: `msdynamics/field-mappings/${id}/value-map/refresh`, method: "POST" }),
			invalidatesTags: ["Dynamics"],
		}),
		/** A user's choice for one key of a value map; an empty value writes nothing (PREC-4363). */
		setDynamicsValueMapEntry: builder.mutation<
			MsdynamicsFieldMapping,
			{ id: number; sourceKey: string; targetValue: string; targetLabel?: string | null }
		>({
			query: ({ id, ...body }) => ({
				url: `msdynamics/field-mappings/${id}/value-map`,
				method: "PUT",
				body,
			}),
			invalidatesTags: ["Dynamics"],
		}),
	}),
});

export const { useRefreshDynamicsValueMapMutation, useSetDynamicsValueMapEntryMutation } =
	dynamicsValueMapApi;
